import { Component, OnInit, Input } from '@angular/core';
import { AllCommunityModules } from '@ag-grid-community/all-modules';
import { throwError } from 'rxjs';
import { ConfigurationService } from 'src/services/configuration.service';

@Component({
  selector: 'app-source-summary',
  templateUrl: './source-summary.component.html',
  styleUrls: ['./source-summary.component.css']
})
export class SourceSummaryComponent implements OnInit {
  @Input() summaryByYearList: any;
  public columnDefs = [
    {
      headerName: 'Source',
      field: 'sourceName',
      pinned: 'left',
      width: 120
    }
  ];
  private gridApi: any;
  public sourceList = [];
  public gridOptions: any;
  public gridOptionsVariation: any;
  public sourceHeader = [];
  public gridData = [];
  public gridList = [];
  public getRowHeight;
  public  headerHeight;
  public gridListVariation = [];
  public columnDefsVariation = [];
  public channelList = [];
  public channel: any;
  public modules = AllCommunityModules;
  constructor(public configurationService: ConfigurationService) {
    this.gridOptions = {
      frameworkComponents: {},
      pagination: true,
      paginationAutoPageSize: true,
    };
    this.gridOptionsVariation = {
      frameworkComponents: {},
      pagination: true,
      paginationAutoPageSize: true,
    };
    this.headerHeight = 30;
    this.gridOptions.getRowHeight = function(params) {
      return 30;
    };
    this.gridOptionsVariation.getRowHeight = function(params) {
      return 30;
    };
  }

  ngOnInit() {
    this.populateList();
  }
  public populateList() {
    this.configurationService.getAllChannels({ clientId: 1 }).subscribe(res => {
      this.channelList = res.data;
    });
  }
  public getCategoryMixFormList = () => {
    this.gridList = [];
    // Get All Same Stores
    this.configurationService.getAllSources({ clientId: 1, channelId: this.channel.channelId }).subscribe((response) => {
      this.sourceList = response.data;
      if (this.sourceList.length > 0) {
        this.sourceList.forEach(async (source: any) => {
          const sourceObject = { sourceName: source.sourcingName };
          const sourceTempList = [];
          const sourceList = await this.configurationService.getSourceMixHeaderList({ clientId: 1, active: true, sourceId: source.sourcingId, channelId: this.channel.channelId }).toPromise().catch(error => {
            return throwError(error);
          });
          // Tenure Type List
          if (sourceList && sourceList.length > 0) {
            this.sourceHeader = sourceList;
            this.sourceHeader.forEach(store => {
              const year = store && store.name ? store.name.split('-')[1] : '';
              if (year && !sourceTempList.includes(year)) {
                sourceTempList.push({ field: `source${year}`, name: year });
              }
            });
            if (sourceTempList.length > 0) {
              sourceTempList.forEach(column => {
                if (!this.columnDefs.find(columnDef => columnDef && columnDef.field === column.field)) {
                  (this.columnDefs as any).push({
                    headerName: column.name,
                    field: column.field,
                    width: 80
                  });
                }
                sourceObject[column.field] = 0;
              });
              if (this.columnDefs.length > 1) {
                this.gridOptions.api.setColumnDefs(this.columnDefs);
              }
            }
          }
          // Goals
          const values = await this.configurationService.getSourceMixFormList({ sourceId: source.sourcingId, clientId: 1, channelId: this.channel.channelId }).toPromise().catch(error => {
            // this.gridList.push({ sourceName: source.sourcingName });
            if (this.sourceList.length > 0 && this.gridList.length === this.sourceList.length) {
              this.mapTotalObject();
            }
            return throwError(error);
          });
          if (values && values.pivotList && values.pivotList.length > 0) {
            const gridData = values.pivotList;
            this.gridData.push(values.pivotList);
            this.gridData = (this.gridData as any).flat();
            gridData.forEach(goal => {
              this.columnDefs.forEach(column => {
                Object.keys(goal).forEach(key => {
                  if (key.substring(7, 11) === column.headerName && goal['SourceMixRow'].name === 'Category N') {
                    if (column.field in sourceObject) {
                      sourceObject[column.field] += goal[key] ? goal[key] : 0;
                    }
                  }
                });
              });
            });
            this.gridList.push(sourceObject);
            if (this.sourceList.length > 0 && this.gridList.length === this.sourceList.length) {
              this.mapTotalObject();
            }
          } else {
            this.gridList.push({ sourceName: source.sourcingName });
            if (this.sourceList.length > 0 && this.gridList.length === this.sourceList.length) {
              this.mapTotalObject();
            }
          }
          this.gridOptions.api.setRowData(this.gridList);
          console.log(this.gridList);
        });
      }
    });
  }
  currencyFormatter(params) {
    return `${Math.floor(typeof params.value === 'number' ? params.value : 0)}%`;
  }
  public mapTotalObject = () => {
    const totalObject: any = {};
    this.gridList.forEach(row => {
      Object.keys(row).forEach(key => {
        totalObject.sourceName = 'Total';
        if (key !== 'sourceName') {
          totalObject[key] = totalObject[key] !== null && totalObject[key] !== undefined ? totalObject[key] + row[key] : row[key];
        }
      });
    });
    this.gridList.push(totalObject);
    this.columnDefs = this.columnDefs.map(column => (column.field !== 'sourceName' ? {
      ...column,
      valueFormatter: this.currencyFormatter
    } : { ...column }));
    this.mapVariationList(JSON.parse(JSON.stringify(this.gridList)));
    this.gridOptions.api.setRowData(this.gridList);
  }
  public mapVariationList = (goalList: any) => {
    const channelSummaryObject = this.summaryByYearList.find(goal => goal.channelName === this.channel.channelName);
    if (channelSummaryObject) {
      const keys = ['sourceName', 'channelName'];
      let channelKeyList = Object.keys(channelSummaryObject ? channelSummaryObject : {});
      if (channelKeyList.length > 0) {
        channelKeyList = channelKeyList.filter(key => !keys.includes(key));
        channelKeyList = channelKeyList.map(key => {
          const value = channelSummaryObject[key];
          const oldKey = key;
          delete channelSummaryObject[key];
          key = oldKey.includes('Channel') ? oldKey.replace('Channel', 'source') : oldKey;
          channelSummaryObject[key] = value;
          return key;
        });
      }
      for (let i = 0; i < goalList.length; i++) {
        let keyList = Object.keys(goalList[i]);
        keyList = keyList.filter(key => !keys.includes(key));
        for (let j = 0; j < keyList.length; j++) {
          if ((goalList[i][keyList[j]]) && channelSummaryObject && channelSummaryObject[keyList[j]]) {
            goalList[i][keyList[j]] = (goalList[i][keyList[j]] / 100) * channelSummaryObject[keyList[j]];
          }
        }
        this.gridListVariation.push(goalList[i]);
        this.gridOptionsVariation.api.setRowData(this.gridListVariation);
      }
    }
    this.columnDefsVariation = this.columnDefs.map(column => (column.field !== 'sourceName' ? {
      ...column,
      valueFormatter: this.currencyFormatterVaraition
    } : { ...column }));
  }
  currencyFormatterVaraition(params) {
    return `${Math.floor(typeof params.value === 'number' ? params.value : 0)}`;
  }
  onGridReady(params) {
    this.gridApi = params.api;
  }
}
